import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { LocationService, Location as AppLocation } from 'app/core/services/location.service';
import { Router } from '@angular/router';

@Component({
    selector: 'location-selector',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatMenuModule, MatIconModule, MatDividerModule],
    templateUrl: './location-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationSelectorComponent implements OnInit {
    private locationService = inject(LocationService);
    private router = inject(Router);

    locations$ = this.locationService.locations$;
    activeLocation$ = this.locationService.activeLocation$;

    ngOnInit() {
        this.locationService.getLocations().subscribe();
    }

    selectLocation(location: AppLocation) {
        if (this.locationService.activeLocationId !== location.id.toString()) {
            this.locationService.setActiveLocation(location, this.getLocationChangeRedirect());
        }
    }

    private getLocationChangeRedirect(): string | undefined {
        const monthlyContextPrefixes = [
            '/user/monthdashboard/',
            '/user/dailyincome/',
            '/user/dailyincomeregister/',
            '/user/purchasedproducts/',
            '/user/dailypurchasedproducts/',
            '/user/workerspayment/',
            '/user/dailyworkerspayments/',
            '/user/dailysupplierspayments/',
            '/user/operationalexpenses/',
            '/user/dailyoperationalexpenses/',
            '/user/dailyusersubcategory/',
            '/user/monthlymileage/',
            '/user/profitsandlossesmonth/',
        ];

        const isInMonthlyContext = monthlyContextPrefixes.some(prefix =>
            this.router.url.startsWith(prefix)
        );

        return isInMonthlyContext ? '/user/dashboard' : undefined;
    }

    manageLocations() {
        this.router.navigate(['/locations']);
    }
}
